import * as React from 'react';
import classNames from 'classnames';

import { DynamicMediaItem } from '@uncinc/react-drupal-core';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import { TaxonomyTheme } from '../../../../types/uncinc_profile/taxonomy';
import {
  ThemeTags,
  WysiwygField,
} from '../../../../components';

import './style.scss';

interface TaxonomyThemeTeaserProps {
  entity: ImmutableEntity<TaxonomyTheme>;
  className?: string;
  childrenEntities?: ImmutableEntity<TaxonomyTheme>[];
}

const TaxonomyThemeTeaser: React.FC<TaxonomyThemeTeaserProps> =
  ({ entity, className, childrenEntities }) => {
    const theme = entity.toJS();
    const title = theme.name[0].value;
    const body = theme.description[0].value;
    const image = theme.field_media_item[0];
    const classes = classNames('TaxonomyThemeTeaser', className);

    // convert childrenEntities to JS array
    const childrenConverted = childrenEntities?.map((childrenTheme) => childrenTheme.toJS());

    return (
      <div className={classes}>
        {image && (
          <DynamicMediaItem
            media={image}
            imageAspectRatio="16_9"
          />
        )}
        <div className="TaxonomyThemeTeaser__content">
          <h2 className="TaxonomyThemeTeaser__title">{title}</h2>
          <WysiwygField html={body} className="TaxonomyThemeTeaser__body" />
          {childrenEntities && <ThemeTags themes={childrenConverted || []} />}
        </div>
      </div>
    );
  };

export default TaxonomyThemeTeaser;
